import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { selectCoopInfo } from "../../../selectors/selectCoopInfo";
import { selectOwnPlayerId } from "../../../selectors/selectPlayerInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionCoopProjectStopSuccess, TypeActionCoopInfo, } from "../actionCoop";
export var epicCoopProjectStop = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionCoopInfo.StopCoopProject), switchMap(function (action) {
        var state = state$.value;
        var playerId = selectOwnPlayerId(state);
        var coopId = selectCoopInfo(state).id;
        return deps
            .netSend({
            id: CommandCode.StopCoopProject,
            props: {
                coopId: coopId,
                playerId: playerId,
                projectId: action.coopProjectId,
            },
        })
            .pipe(switchMap(function (response) {
            var actions = [actionCoopProjectStopSuccess(response)];
            return from(actions);
        }), retry());
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopProjectStop.ts
// module id = 1821
// module chunks = 3